import { render, staticRenderFns } from "./VariantFormElement.vue?vue&type=template&id=55a4382e&scoped=true&"
import script from "./VariantFormElement.vue?vue&type=script&lang=js&"
export * from "./VariantFormElement.vue?vue&type=script&lang=js&"
import style0 from "./VariantFormElement.vue?vue&type=style&index=0&id=55a4382e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a4382e",
  null
  
)

export default component.exports